"use client";

import { useEffect, useRef } from "react";

export default function OurValuesSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll(".reveal");
    if (!els) return;

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            observer.unobserve(e.target);
          }
        }),
      { threshold: 0.1 }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      style={{
        background: "var(--color-navy)",
        paddingTop: "120px",
        paddingBottom: "120px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        {/* Header */}
        <div className="text-center mb-20 reveal reveal-delay-1">
            <p className="type-caption mb-2" style={{ color: "var(--color-red)" }}>OUR VALUES</p>


        <h2
            style={{
                fontFamily: "var(--font-serif)",
                fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
                fontWeight: 400,
                color: "var(--color-white)",
                lineHeight: 1.15,
                letterSpacing: "-0.015em",
            }}
        >
            What Drives Us
          </h2>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-16 reveal reveal-delay-2">
          {[
            {
              title: "Reliability",
              body:
                "Delivery commitments backed by structured production planning.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--color-white)"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <circle cx="12" cy="12" r="4" />
                </svg>
              ),
            },
            {
              title: "Transparency",
              body:
                "Clear formulas, benchmark pricing, and audit-ready documentation.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--color-white)"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              ),
            },
            {
              title: "Compliance",
              body:
                "Export-control awareness, regulatory alignment, and responsible sourcing.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--color-white)"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              ),
            },
            {
              title: "Partnership",
              body:
                "We structure deals for mutual value creation.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--color-white)"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 2l4 4-6 6-4-4z" />
                  <path d="M8 14l4 4-6 6-4-4z" />
                </svg>
              ),
            },
          ].map((item) => (
            <div key={item.title} className="text-center">
              {/* Icon Box */}
              <div
                style={{
                  background: "var(--color-navy-mid)",
                  width: "72px",
                  height: "72px",
                  margin: "0 auto 24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--color-red)",
                }}
              >
                {item.icon}
              </div>

              {/* Title */}
              <h4
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "1.25rem",
                  fontWeight: 400,
                  color: "var(--color-white)",
                  marginBottom: "12px",
                }}
              >
                {item.title}
              </h4>

              {/* Body */}
              <p
                style={{
                  fontFamily: "var(--font-sans)",
                  fontSize: "0.95rem",
                  color: "rgba(255,255,255,0.6)",
                  lineHeight: 1.6,
                  maxWidth: "260px",
                  margin: "0 auto",
                }}
              >
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}